import { Component } from 'react';
import Input from './Input';

class TextField extends Component {
  render() {
    const {
      className,
      style,
      isValid,
      InputProps,
      disabled,
      enableError,
      rows,
      keyPress,
      keyDown,
      min,
      inputRef,
      select,
      MenuItems,
      SelectProps,
      rowsMax,
      multiline,
      wordCount,
      limit,
      topic,
      error,
      onChange,
      ...others
    } = this.props;
    return (
      <Input
        disabled={disabled}
        wordCount={wordCount}
        limit={limit}
        inputRef={inputRef}
        className={className}
        rows={rows}
        min={min}
        multiline={multiline}
        rowsMax={rowsMax}
        style={style}
        topic={topic}
        error={error}
        valid={isValid}
        InputProps={InputProps}
        onKeyPress={keyPress}
        onKeyDown={keyDown}
        select={select}
        MenuItems={MenuItems}
        SelectProps={SelectProps}
        enableError={enableError}
        onChange={onChange}
        {...others}
      />
    );
  }
}

TextField.defaultProps = {
  topic: 'default',
  enableError: false,
};

export default TextField;
